import React from 'react';
import I18n from 'i18n-js';

import { RCButton, RCToast } from '@reverbdotcom/cadence/components';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import SellerListingsCollectionContext from '../listings_management/SellerListingsCollectionContext';
import RenewListingModal from './RenewListingModal';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface IExternalProps {
  listing: Listing;
  onClick?: () => void;
}

export default function RenewListingButton({
  listing,
  onClick = () => { },
}: IExternalProps) {
  const {
    useLazySellerListingsQuery,
  } = React.useContext(SellerListingsCollectionContext);

  const { refetchSellerListings } = useLazySellerListingsQuery();

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [toastOpen, setToastOpen] = React.useState(false);

  const openModal = () => {
    onClick();
    // subtract listing publication date in seconds from  current time in seconds
    // (Date.now() returns ms; convert to seconds by dividing by 1000)
    // divide resulting number of seconds by the total number of seconds in a day (60 * 60 * 24)
    const publishedAtSeconds = listing.publishedAt?.seconds;
    const nowSeconds = Math.floor(Date.now() / 1000);

    const listingAgeInDays = publishedAtSeconds ? Math.floor((nowSeconds - publishedAtSeconds) / 86400) : null;

    const sellerPrice = listing.sellerPrice?.amountCents;
    const highPrice = listing.priceRecommendation?.priceHigh?.amountCents;
    const isCompetitivelyPriced = (highPrice && sellerPrice) ? sellerPrice < highPrice : null;

    trackEvent({
      componentName: 'RenewListingButton',
      eventName: MParticleEventName.StartedRenewListingFlow,
      listingId: listing.id,
      listingAgeInDays,
      isMatched: !!listing.canonicalProductId,
      isCompetitivelyPriced,
    });

    setIsModalOpen(true);
  };

  return (
    <div>
      <RCButton
        variant="outlined"
        size="small"
        title={I18n.t('discovery.listingsManagement.renewListing.button')}
        onClick={openModal}
        fullWidth
      >
        {I18n.t('discovery.listingsManagement.renewListing.button')}
      </RCButton>

      <RenewListingModal
        isOpen={isModalOpen}
        listing={listing}
        requestClose={() => setIsModalOpen(false)}
        onSuccessCallback={() => {
          setIsModalOpen(false);
          refetchSellerListings([listing.id]);
          setToastOpen(true);
        }}
      />

      <RCToast
        isOpen={toastOpen}
        onClose={() => setToastOpen(false)}
        text={I18n.t('discovery.listingsManagement.renewListing.successFlash')}
        theme="success"
      />
    </div>
  );
}
